import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEmail = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M13.375 31.708c0-8.642 0-12.963 2.685-15.648s7.006-2.685 15.648-2.685c8.643 0 12.964 0 15.649 2.685s2.685 7.006 2.685 15.648c0 8.643 0 12.964-2.685 15.649s-7.006 2.685-15.649 2.685-12.963 0-15.648-2.685-2.685-7.006-2.685-15.649"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.667 31.708c0-4.36-.004-7.492-.324-9.875-.316-2.344-.915-3.756-1.959-4.8s-2.457-1.644-4.8-1.959c-2.383-.32-5.516-.324-9.876-.324s-7.492.004-9.875.324c-2.344.315-3.756.914-4.8 1.959s-1.644 2.456-1.959 4.8c-.32 2.383-.324 5.515-.324 9.875s.004 7.493.324 9.876c.315 2.343.915 3.756 1.959 4.8s2.456 1.644 4.8 1.959c2.383.32 5.515.324 9.875.324s7.493-.004 9.876-.324c2.343-.316 3.756-.915 4.8-1.959s1.644-2.457 1.959-4.8c.32-2.383.324-5.516.324-9.876m2.75 0c0 4.282.003 7.632-.348 10.241-.356 2.649-1.1 4.739-2.74 6.38-1.641 1.64-3.731 2.384-6.38 2.74-2.609.351-5.959.348-10.24.348-4.283 0-7.632.003-10.242-.348-2.648-.356-4.738-1.1-6.379-2.74s-2.385-3.731-2.74-6.38C11.996 39.34 12 35.99 12 31.71c0-4.283-.003-7.632.347-10.242.356-2.648 1.1-4.738 2.741-6.379 1.64-1.64 3.73-2.385 6.38-2.74 2.608-.351 5.958-.348 10.24-.348s7.632-.003 10.241.347c2.649.356 4.739 1.1 6.38 2.741 1.64 1.64 2.384 3.73 2.74 6.38.351 2.608.348 5.958.348 10.24"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M34.734 31.708a3.026 3.026 0 1 0-6.052.001 3.026 3.026 0 0 0 6.052 0m2.75 2.795a1.625 1.625 0 0 0 2.727 1.194l.147-.136h.001c.204-.187.331-.379.396-.557v-.001a9.6 9.6 0 0 0 .578-3.295 9.625 9.625 0 1 0-19.25 0 9.625 9.625 0 0 0 9.625 9.625 1.375 1.375 0 1 1 0 2.75c-6.834 0-12.375-5.54-12.375-12.375 0-6.834 5.54-12.375 12.375-12.375s12.375 5.54 12.375 12.375c0 1.486-.262 2.913-.744 4.236-.183.502-.461.935-.783 1.298l-.333.34-.147.137a4.376 4.376 0 0 1-6.935-1.375 5.74 5.74 0 0 1-3.433 1.14 5.776 5.776 0 1 1 5.776-5.776z"
      />
    </svg>
  );
};
export default SvgEmail;
